export enum IsAdminActionType {
    REQUEST_IS_ADMIN = 'REQUEST_IS_ADMIN',
    RECEIVE_IS_ADMIN = 'RECEIVE_IS_ADMIN',
}

export type IsAdminAction = IRequestIsAdminAction | IReceiveIsAdminAction;

export interface IRequestIsAdminAction {
    type: IsAdminActionType.REQUEST_IS_ADMIN;
}

export interface IReceiveIsAdminAction {
    type: IsAdminActionType.RECEIVE_IS_ADMIN;
    isAdmin: boolean;
}
